module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/sprite-main/icon-creditcard-390a9e8f87d0af74487005ce36cb13dc.svg";